import React, { useState, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { useStore } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
} from "reactstrap";
import { AvForm, AvGroup, AvField } from "availity-reactstrap-validation";

import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";

const dataService = require("../../services/dataServices.js");

const EditWord = () => {
  let { word_id } = useParams();
  const navigate = useHistory();
  const [word, setWord] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const store = useStore();
  const currentUser =
    store.getState().authentication.user ??
    (localStorage.getItem("user") !== null
      ? JSON.parse(localStorage.getItem("user"))
      : null);

  async function constructObject() {
    var obj = {
      word_id: word_id,
      word: word,
      allow_on_home_flag: 1,
    };

    return obj;
  }

  async function save() {
    setIsLoading(true);
    setIsDisabled(true);

    var obj = await constructObject();
    await dataService.updateWord(obj);

    showToastr();
  }

  function performCancel() {
    navigate.push("/system-content/banned-words/");
  }

  useEffect(() => {
    async function loadData() {
      // load the role
      var data = await dataService.word(word_id);

      setWord(data.word);
      setIsLoading(false);
      setIsDisabled(!hasWritePermission());
    }

    function hasWritePermission() {
      var result = false;

      if (currentUser.permissions) {
        const matchIndex = currentUser.permissions.findIndex(function (row) {
          return row === "banned_words_write";
        });
        if (matchIndex > -1) {
          result = true;
        }
      } else {
        result = true;
      }

      return result;
    }

    loadData();
  }, [word_id, currentUser]);

  function showToastr() {
    const options = {
      timeOut: 3000,
      showCloseButton: true,
      progressBar: false,
      position: "top-center",
      onHideComplete: () => {
        setIsLoading(false);
        setIsDisabled(false);
      },
    };
    const toastrInstance = toastr.success;
    toastrInstance(
      "Edit Banned Word",
      "Your changes have been saved successfully.",
      options
    );
  }

  return (
    <Container fluid>
      <Header>
        <HeaderTitle>Edit Banned Word</HeaderTitle>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/dashboard">Dashboard</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/system-content/banned-words">Banned Words</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Edit Banned Word</BreadcrumbItem>
        </Breadcrumb>
      </Header>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <AvForm onValidSubmit={save}>
                <Row>
                  <Col>
                    <AvGroup>
                      <Label for="word">Word</Label>
                      <AvField
                        bsSize="lg"
                        type="text"
                        name="word"
                        id="word"
                        placeholder="Enter word"
                        value={word}
                        disabled={isDisabled}
                        onChange={(e) => setWord(e.target.value)}
                        validate={{
                          required: {
                            value: true,
                            errorMessage: "Please enter a word.",
                          },
                        }}
                      />
                    </AvGroup>
                  </Col>
                </Row>
                <div className="mt-3">
                  <Button
                    color="light"
                    size="lg"
                    className="mr-2"
                    onClick={performCancel}
                  >
                    Cancel
                  </Button>
                  <Button color="primary" size="lg" disabled={isDisabled}>
                    {isLoading && (
                      <Spinner size="sm" className="mr-2 align-middle" />
                    )}
                    Save
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EditWord;
